import { SelectOption } from '@thought-river/ui-components';
import { IReviewStream } from '../../resources/AuthResource-types';

export function formatStreamOption(stream: IReviewStream): SelectOption {
    return {
        value: stream.accountCode,
        label: stream.accountName,
    };
}
